import { NotificationService } from 'src/app/shared/services/notification.service';
import { UserRole } from './../../follow-ups/models/deviation';

import { EmployeeServices } from './../services/employee.services';
import { HelperService } from './../../../_services/helper.service';

import { Location } from '@angular/common';
import { inject, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';

import { EmployeePrivateDocumentServices } from './../services/employeeprivatedocument.service';
import { BaseServices } from 'src/app/kuba/kuba.services';
import { FileUploadService } from 'src/app/_services/fileUpload.service';
import { UploaderConfig } from 'src/app/shared/ecpl-document-explorer/uploader-config';
import { EmployeeDocumentUploadable } from 'src/app/kuba/employees/models/employeeDocument';
import { AppErrorCode, FeatureKey } from 'src/app/_models';
import { SelectItem } from 'primeng/api';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { HttpErrorResponse } from '@angular/common/http';
import * as _ from 'lodash';
import { getFileExtension } from 'src/app/kuba/shared/helpers/file.helper';
import { Subscription } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import {
  Department,
  DropdownOption
} from '../../businesses/models/businessDepartment';

@Component({
  selector: 'private-doc',
  templateUrl: 'employee-privatedocument.component.html',
  standalone: false
})
export class PrivateDocumentComponent implements OnInit {
  private readonly notifications = inject(NotificationService);
  //#region variables
  additionalData: any;
  loading = false;
  upConfig: UploaderConfig;
  upConfigApp: UploaderConfig;
  UploadableFile: EmployeeDocumentUploadable;
  newDocumentAdded: any = [];
  uploadedFiles: any = [];
  employeeId: number;
  docId: number;
  isShowDelete: boolean;
  editMode = false;
  showSavingLoader = false;
  isEditor = false;
  isUser = false;
  featureId: any;
  selectedArticles: any = [];
  selectedFiles: any;
  isMultiDocument = false;
  employees: any = [];
  emp: any = [];
  rowID: number = null!;
  isCollapsed = false;
  employeeForm: FormGroup;
  selectedEmployees: SelectItem[];
  selectedEmployeesForApproval: any = [];
  files: any = [];
  selectedDocumentsForApprovalNotice: any = [];
  type: any;
  all = false;
  title: any = 'APPROVAL_DOCUMENTS';
  typeList: any = [];
  originalEmp: any = [];
  private subscriptions: Subscription[] = [];
  safeURL: any;
  isVideo = false;
  isPortal: boolean;
  departments: Department[];
  departmentOptions: DropdownOption[];
  //#endregion

  //#region constructor
  /**
   *  constructor
   * @param route {ActivatedRoute}
   * @param fileUploadService {FileUploadService}
   * @param location {Location}
   * @param privateDocSvc {EmployeePrivateDocumentServices}
   */
  constructor(
    private route: ActivatedRoute,
    private employeePrivateDocumentServices: EmployeePrivateDocumentServices,
    private employeeServices: EmployeeServices,
    private translate: TranslateService
  ) {
    //#endregion
    this.employeeId = route.snapshot.params['eid'];
    this.type = +route.snapshot.params['mId'];
    console.log('type', this.type);
    if (this.type == 1) {
      this.title = 'APPROVAL_DOCUMENTS';
      this.isMultiDocument = true;
      if (BaseServices.roleId !== '2') {
        this.subscriptions.push(
          this.employeeServices
            .list(BaseServices.BusinessId)
            .subscribe(result => {
              if (result) {
                result.forEach((r: any) => {
                  this.employees.push({
                    label: r.Name,
                    value: r.Id
                  });
                });
              }
            })
        );
      }
      this.emp = this.route.snapshot.data['applist'];
      this.originalEmp = this.route.snapshot.data['applist'];
      this.subscriptions.push(
        this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
          this.typeList = [];
          this.typeList.push({ label: val.SELECT, value: null });
          var types = this.emp
            .map((item: any) => item.TypeOfEmployee)
            .filter(
              (value: any, index: any, self: any) =>
                self.indexOf(value) === index
            );
          types.forEach((element: any) => {
            this.typeList.push({ label: element, value: element });
          });
        })
      );
    }

    if (BaseServices.roleId == '3') {
      if (
        BaseServices.userBase.UserFeatureKey == this.employeeId &&
        !BaseServices.IsRmode
      )
        this.isUser = true;
      else this.isEditor = true;
    }
    if (
      (BaseServices.roleId == '4' || BaseServices.roleId == '5') &&
      BaseServices.userBase.UserFeatureKey == this.employeeId
    ) {
      this.isUser = true;
    }
    // TODO: need to send dynamic values
    this.additionalData = {
      ApplicationId: BaseServices.ApplicationId,
      BusinessId: BaseServices.BusinessId,
      EmployeeId: this.employeeId,
      IsPrivateDocument: true,
      Status: '1',
      CreatedBy: BaseServices.UserId,
      CreatedOn: '',
      ModifiedBy: BaseServices.UserId,
      ModifiedOn: '',
      IsDocumentedTraining: false
    };
    this.upConfig = {
      title: 'PRIVATE_DOCUMENTS',
      viewSwitch: true,
      IsPrivateUploadButton: true,
      showDeleteButton: false,
      editMode: this.editMode,
      windowedHeight: false,
      showUserMeta: false,
      showSearchFilter: false,
      uploaderUri:
        environment.BASE_URL + '/file/upload/business/employee/private-docs',
      addtionalData: this.additionalData,
      isEditablePrivateDocument: true,
      pdEmpId: this.employeeId
    };
    this.upConfigApp = {
      title: null!,
      titleAsLabel: true,
      editMode: true,
      windowedHeight: false,
      viewSwitch: false,
      showUserMeta: false,
      showSearchFilter: false,
      IsPrivateUploadButton: true,
      showDeleteButton: true,
      uploaderUri:
        environment.BASE_URL + '/file/upload/business/employee/private-docs',
      addtionalData: this.additionalData,
      pdEmpId: this.employeeId
    };
  }
  /**
   * file upload events
   * @param event {any}
   */
  isFileSeclected() {
    this.selectedFiles = this.uploadedFiles.filter(
      (x: any) => x.selected == true
    );
    if (this.selectedFiles.length > 0) return false;
    else return true;
  }

  setCollapse(i: number): boolean {
    let isCollapsed = i === this.rowID;
    return !isCollapsed;
  }

  toggleClick(i: number): void {
    this.rowID = i;
    this.isCollapsed = !this.isCollapsed;
  }

  toggleClickHide(i: number): void {
    this.rowID = null!;
  }
  saveUploaded(event: any) {
    if (event) {
      let eventType = event.eventName;
      switch (eventType) {
        case 'DeleteDefaultFile':
          if (event.item.data.id === 0) {
            // remove unsaved attachment
            this.newDocumentAdded = this.newDocumentAdded.filter(
              (x: any) => x.Path !== event.item.data.path
            );
            this.uploadedFiles = this.uploadedFiles.filter(
              (x: any) => x.path !== event.item.data.path
            );
            this.notifications.success('UI_NOTIFICATIONS.DELETED');
          } else {
            // remove existing attachement
            this.subscriptions.push(
              this.employeeServices
                .deleteEmployeeDocument(event.item.data.id)
                .subscribe((result: any) => {
                  if (result) {
                    this.newDocumentAdded = this.newDocumentAdded.filter(
                      (x: any) => x.Path !== event.item.data.path
                    );
                    // remove from display list
                    this.uploadedFiles = this.uploadedFiles.filter(
                      (x: any) => x.path !== event.item.data.path
                    );
                    this.notifications.success('UI_NOTIFICATIONS.DELETED');
                  }
                })
            );
          }
          break;
        case 'remove':
          this.uploadedFiles = this.uploadedFiles.filter(
            (x: any) => x.id !== +event.id
          );
          break;
        case 'ShowOfficeFileSaveloader':
          this.subscriptions.push(
            this.employeePrivateDocumentServices
              .updateDoc(event.item.id, this.employeeId, false)
              .subscribe(res => {
                this.docId = event.item.id;
                if (res) {
                  this.subscriptions.push(
                    this.employeePrivateDocumentServices
                      .list(this.employeeId, 1)
                      .subscribe(result => {
                        if (result.length > 0) {
                          this.uploadedFiles = result;
                          this.Approve(1);
                        }
                      })
                  );
                }
              })
          );
          if (parseInt(sessionStorage.getItem('isDocumentChanged')!, null!)) {
            this.showSavingLoader = true;
            setTimeout(() => {
              this.showSavingLoader = false;
              this.newDocumentAdded = [];
            }, 15000);
            sessionStorage.setItem('isDocumentChanged', '0');
          }
          break;
        default:
          let keyBindings = {
            Originalname: 'OriginalFileName',
            FileTypeId: 'FileType'
          };
          let privateDoc = Object.assign({}, event, this.additionalData);
          privateDoc.id = 0;
          privateDoc.status = '1';
          privateDoc.createdBy = BaseServices.UserId;
          this.newDocumentAdded.push(
            HelperService.switchKeysCase(privateDoc, keyBindings)
          );

          break;
      }
    }
  }

  saveDoc() {
    if (this.isMultiDocument == true) {
      if (
        this.newDocumentAdded.length > 0 &&
        this.selectedEmployeesForApproval.length > 0
      ) {
        this.loading = true;
        this.newDocumentAdded.forEach((element: any) => {
          this.selectedEmployeesForApproval.forEach((x: any) => {
            var tempDoc: any = {};
            tempDoc.BusinessId = element.BusinessId;
            tempDoc.CreatedBy = element.CreatedBy;
            tempDoc.CreatedOn = element.CreatedOn;
            tempDoc.EmployeeId = x.EmployeeId;
            tempDoc.Extension = element.Extension;
            tempDoc.FileType = element.FileType;
            tempDoc.Filename = element.Filename;
            tempDoc.Id = element.Id;
            tempDoc.IsPrivateDocument = element.IsPrivateDocument;
            tempDoc.Mimetype = element.Mimetype;
            tempDoc.ModifiedBy = element.ModifiedBy;
            tempDoc.ModifiedOn = element.ModifiedOn;
            tempDoc.OriginalFileName = element.OriginalFileName;
            tempDoc.Path = element.Path;
            tempDoc.Size = element.Size;
            tempDoc.Status = element.Status;
            tempDoc.IsDocumentedTraining = false;
            this.files.push(tempDoc);
          });
        });
        this.subscriptions.push(
          this.employeePrivateDocumentServices
            .saveDocs(this.files)
            .subscribe(result => {
              if (result) {
                this.notifications.success('UI_NOTIFICATIONS.SAVED');
                this.loading = false;
                this.newDocumentAdded = [];
                this.getApprovalDoc();
                this.selectedEmployeesForApproval = [];
                this.uploadedFiles = [];
                this.files = [];
              }
            })
        );
      }
    } else {
      if (this.newDocumentAdded.length > 0) {
        this.loading = true;
        this.newDocumentAdded.forEach((X: any) => {
          X.IsDocumentedTraining = false;
        });
        this.subscriptions.push(
          this.employeePrivateDocumentServices
            .save(this.newDocumentAdded, this.employeeId)
            .subscribe(result => {
              if (result) {
                this.notifications.success('UI_NOTIFICATIONS.SAVED');
                this.loading = false;
                this.newDocumentAdded = [];
                this.getDoc();
              }
            })
        );
      }
    }
  }

  getApprovalDoc() {
    this.employeePrivateDocumentServices
      .getApprovalDocuments(
        this.employeeId,
        BaseServices.BusinessId,
        BaseServices.PortalId,
        1
      )
      .subscribe(result => {
        this.emp = result;
        this.originalEmp = result;
        this.subscriptions.push(
          this.translate.stream('SELECT').subscribe(val => {
            this.typeList = [];
            this.typeList.push({ label: val.SELECT, value: null });
            var types = this.emp
              .map((item: any) => item.TypeOfEmployee)
              .filter(
                (value: any, index: any, self: any) =>
                  self.indexOf(value) === index
              );
            types.forEach((element: any) => {
              this.typeList.push({ label: element, value: element });
            });
          })
        );
      });
  }
  //#endregion

  //#region page-events
  /**
   * page initialization
   */
  ngOnInit() {
    document.querySelector('body').classList.remove('opened');
    this.isPortal = +BaseServices.roleId === UserRole.PORTAL ? true : false;
    let uploadfiles = this.route.snapshot.data['list'];
    if (uploadfiles && uploadfiles.length > 0) {
      this.uploadedFiles = uploadfiles;
    }
    this.setupDepartmentsDropdown();
  }

  ngOnChanges() {
    this.selectedFiles = this.uploadedFiles.filter(
      (x: any) => x.selected == true
    );
  }

  setupDepartmentsDropdown(): void {
    const departmentsFromRoute: Department[] =
      this.route.snapshot.data['busDepartment'];

    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.departmentOptions = [];
        this.departmentOptions.push({ label: val.SELECT, value: null });
      })
    );

    if (departmentsFromRoute) {
      departmentsFromRoute.forEach((department: Department) => {
        this.departmentOptions.push({
          label: department.Name,
          value: department.Name
        });
      });
    }
  }

  getDoc() {
    this.subscriptions.push(
      this.employeePrivateDocumentServices
        .list(this.employeeId, 1)
        .subscribe(result => {
          this.uploadedFiles = result;
        })
    );
  }
  getApprovalDocuments() {
    this.loading = true;
    this.employeePrivateDocumentServices
      .getApprovalDocuments(
        this.employeeId,
        BaseServices.BusinessId,
        BaseServices.PortalId,
        1
      )
      .subscribe(result => {
        this.emp = result;
        this.originalEmp = result;
        this.subscriptions.push(
          this.translate.stream('SELECT').subscribe(val => {
            this.typeList = [];
            this.typeList.push({ label: val.SELECT, value: null });
            var types = this.emp
              .map((item: any) => item.TypeOfEmployee)
              .filter(
                (value: any, index: any, self: any) =>
                  self.indexOf(value) === index
              );
            types.forEach((element: any) => {
              this.typeList.push({ label: element, value: element });
            });
          })
        );
        this.loading = false;
      });
  }

  toggleEditMode(mode: any) {
    this.editMode = mode;
    this.upConfig.editMode = mode;
    this.upConfig.showDeleteButton = mode;
  }

  onTableHeaderCheckboxToggle() {
    this.selectedEmployeesForApproval = this.emp;
  }

  /**
   * Returns true if the document has not yet been approved
   */
  hasUnapprovedDocument = (doc: any) => doc.approvedOn == null;

  Approve(isSendApproval: number) {
    if (isSendApproval === 3) {
      // Employee approving their own selected documents
      this.loading = true;
      const documentIds = this.uploadedFiles
        .filter((x: any) => x.selected)
        .map((x: any) => ({ documentId: x.id }));
      this.subscriptions.push(
        this.employeePrivateDocumentServices
          .approveDocuments(documentIds)
          .subscribe({
            next: () => {
              this.notifications.success('UI_NOTIFICATIONS.APPROVED');
              this.loading = false;
              this.getDoc();
            },
            error: (err: HttpErrorResponse) => {
              this.loading = false;
              this.showGenericErrorToast(err.status);
            }
          })
      );
      return;
    }

    // isSendApproval === 1 — editor/admin sending approval notification to employee
    if (this.newDocumentAdded.length > 0) {
      // Files to upload — save first, then send approval notification
      this.loading = true;
      this.newDocumentAdded.forEach(
        (x: any) => (x.IsDocumentedTraining = false)
      );
      this.subscriptions.push(
        this.employeePrivateDocumentServices
          .save(this.newDocumentAdded, this.employeeId)
          .subscribe(result => {
            if (result) {
              this.notifications.success('UI_NOTIFICATIONS.SAVED');
              this.newDocumentAdded = [];
              this.getDoc();
              this.subscriptions.push(
                this.employeePrivateDocumentServices
                  .sendApprovalRequest([{ employeeId: this.employeeId }])
                  .subscribe({
                    next: () => {
                      this.notifications.success(
                        'UI_NOTIFICATIONS.APPROVAL_SENT'
                      );
                      this.loading = false;
                    },
                    error: (err: HttpErrorResponse) => {
                      this.loading = false;
                      if (err.status === 404) this.showNoDocumentsToast();
                      else if (err.error?.Code === AppErrorCode.UserLacksEmail)
                        this.showMissingEmailToast(err.error.Detail);
                      else this.showGenericErrorToast(err.status);
                    }
                  })
              );
            }
          })
      );
    } else {
      // No new files — send notification directly, backend checks for unapproved documents
      this.loading = true;
      this.subscriptions.push(
        this.employeePrivateDocumentServices
          .sendApprovalRequest([{ employeeId: this.employeeId }])
          .subscribe({
            next: () => {
              this.notifications.success('UI_NOTIFICATIONS.APPROVAL_SENT');
              this.loading = false;
            },
            error: (err: HttpErrorResponse) => {
              this.loading = false;
              if (err.status === 404) this.showNoDocumentsToast();
              else this.showGenericErrorToast(err.status);
            }
          })
      );
    }
  }

  /**
   * Shows a generic error toast using the same translation keys as the global interceptor.
   * Called when sendApprovalRequest fails with a non-404 status code,
   * since SKIP_ERROR_TOAST bypasses the interceptor's error handling for this endpoint.
   */
  private showGenericErrorToast(status: number): void {
    this.notifications.add({
      severity: 'error',
      summary: this.translate.instant('GENERAL_ERROR.UNEXPECTED_ERROR_TITLE', {
        status
      }),
      detail: this.translate.instant('GENERAL_ERROR.UNEXPECTED_ERROR_MESSAGE', {
        status,
        technicalSupport: this.translate.instant(
          'PLEASE_CONTACT_TECHNICAL_TEAM'
        )
      })
    });
  }

  /**
   * Shows a warning toast in the user's language when the employee has no documents requiring approval
   */
  private showNoDocumentsToast(): void {
    const lang = sessionStorage.getItem('languageMode');
    const summary =
      lang === 'no-NO'
        ? 'Ingen dokumenter'
        : lang === 'sv-SE'
          ? 'Inga dokument'
          : 'No documents';
    const detail =
      lang === 'no-NO'
        ? 'Den ansatte har ingen dokumenter som venter på godkjenning'
        : lang === 'sv-SE'
          ? 'Den anställde har inga dokument som väntar på godkännande'
          : 'The employee has no documents awaiting approval';
    this.notifications.add({
      severity: 'warn',
      summary: summary,
      detail: detail
    });
  }

  private showMissingEmailToast(detail: string): void {
    const lang = sessionStorage.getItem('languageMode');
    const summary =
      lang === 'no-NO'
        ? 'Manglende e-postadresse'
        : lang === 'sv-SE'
          ? 'Saknar e-postadress'
          : 'Missing email address';
    this.notifications.add({
      severity: 'warn',
      summary: summary,
      detail: detail
    });
  }

  choose(event: any) {}

  getFileExtension(filename: string): string {
    return getFileExtension(filename);
  }
  checkIfAllSelected() {
    this.all = !this.all;
  }
  filterResults(data: any) {
    if (data == null || data == '') {
      this.emp = this.originalEmp;
    } else {
      var arr: any = [];
      this.originalEmp.forEach((x: any) => {
        var filter = [];
        if (x.EmployeeDocuments != null && x.EmployeeDocuments.length > 0) {
          x.EmployeeDocuments.forEach((ele: any) => {
            if (
              ele.Filename != null &&
              ele.Filename.toLowerCase().includes(data.toLowerCase())
            )
              filter.push(ele);
          });
          if (filter.length > 0) arr.push(x);
        }
      });
      this.emp = arr;
    }
  }

  deleteDoc(id: number) {
    this.loading = true;
    this.employeePrivateDocumentServices.delete(id).subscribe(res => {
      this.loading = false;
      this.notifications.success('UI_NOTIFICATIONS.DELETED');
      this.selectedArticles = [];
      this.getApprovalDocuments();
    });
  }
  ngOnDestroy() {
    this.subscriptions.forEach((sub, i) => {
      sub.unsubscribe();
    });
  }
  //#endregion
}
